import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { useTheme } from '../contexts/ThemeContext';
import { cn } from '../lib/utils';
import { getUIConfig } from '../config/appConfig';
import { SIDEBAR_COLLAPSED_KEY } from '../config/menuSidebarUtils';

const MainLayout = ({ children, onLogout, userRole = 'admin', pageTitle }) => {
  const { theme } = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    try {
      const stored = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
      if (stored !== null) return stored === 'true';
    } catch {
      /* ignore */
    }
    return getUIConfig('sidebar')?.defaultCollapsed || false;
  });

  const handleSidebarCollapsed = (value) => {
    setSidebarCollapsed(value);
    try {
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(value));
    } catch {
      /* ignore */
    }
  };

  return (
    <div className={cn('flex h-screen', theme.gradients.background)}>
      <Sidebar 
        isOpen={sidebarOpen} 
        setIsOpen={setSidebarOpen} 
        userRole={userRole} 
        onLogout={onLogout}
        collapsed={sidebarCollapsed}
        setCollapsed={handleSidebarCollapsed}
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header 
          sidebarOpen={sidebarOpen} 
          setSidebarOpen={setSidebarOpen}
          pageTitle={pageTitle}
          userRole={userRole}
        />
        
        <main className={cn('flex-1 overflow-x-hidden overflow-y-auto p-3', theme.colors.background)}>
          {children}
        </main>
        
        {getUIConfig('showFooter') && <Footer />}
      </div>
    </div>
  );
};

export default MainLayout;